export default "__VITE_ASSET__GpODjbtv__"